/* eslint-disable no-restricted-imports */
import {createRoot, Root} from 'react-dom/client'
import {createElement} from 'react'
import UIGame, {UIGameProps} from './core/UIGame'
import {flushSync} from 'react-dom'

export type {FeedMessageData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageData'
export {resizeUIGame} from './core/UIGame'
export {createFeedMessageDataForGameLogData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs'
export {createFeedMessageDataForGameChatData} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataChats'
export {setGlobalGameState} from './contexts/UIGameStateContext'
export {setGlobalGameSettings} from './core/UIGame'
export {setGlobalFocusLogIndex} from './contexts/UIGameReplayContext'
export {setGlobalMutePlayer} from './contexts/UIMutePlayerContext'
export {setGlobalGameEndProviderProps, setGlobalGameEndNumberOfPlayersJoinedRematch, setGlobalGameEndIsVisible, getGlobalGameEndIsVisible} from './core/UIGameEnd'
export {addGlobalSpectatorMessage} from './core/UIGameFeeds/UIGameChat/UIGameChat'
export {addNewLog} from './core/UIGameFeeds/UIGameLog/UIGameLog'
export {CARD_TOOLTIP_LINK_PREFIX} from './core/UIGameFeeds/UIGameFeedMessage/FeedMessageDataLogs'
export {setGlobalIsPaused, setGlobalRemainingPauseTimeMS} from './core/UIGamePause/UIGamePauseContext'
export {setGlobalCanResign} from './core/UIGameHelpButtons/UIGameHelpLeaveGameContext'
export {getCostInformation} from './core/UIGameHelpButtons/UIGameHelpInformationButton/UIGameHelpCostsInformation/UIGameCostsInformation'
export {setGlobalSpectators} from './core/UIGameSpectators/UIGameSpectatorsContext'
export {setGlobalVoteState} from './core/UIGameVote/UIGameVoteContext'
export {CARD_IMAGES} from './utils/cards.ts'
export {VICTORY_POINT_IMAGES} from './utils/vp.ts'
export {CurrentStateMessageUtils, type CurrentStateMessageInput} from './core/UIGameCurrentStatus/CurrentStateMessageUtils'

let reactRoot: Root | null = null

export const renderUIGame = (props: UIGameProps) => {
    const {gameManager} = props
    let container = document.getElementById('ui-game') as HTMLDivElement | null
    if(container && reactRoot) {
        reactRoot.unmount()
        reactRoot = null
    }
    if(!container) {
        container = document.createElement('div')
        container.id = 'ui-game'
        container.style.pointerEvents = 'none'
        container.style.position = 'absolute'
        container.style.left = gameManager.canvasController.app.view.style.left
        container.style.width = gameManager.canvasController.appW + 'px'
        container.style.height = gameManager.canvasController.appH + 'px'
        document.body.appendChild(container)
    }

    reactRoot = createRoot(container)
    // TODO remove flushSync when everything migrated to React
    flushSync(() => {
        reactRoot?.render(createElement(UIGame, props))
    })
}
